export default {
  title: 'Plans',

  labels: {
    calculateCurrentSubscription: 'Calculate current subscription credit',
    code: 'Code',
    name: 'Name',
    period: 'Period time (per Month)',
    price: 'Monthly price',
    free: 'Free',
    salePrice: 'Sale price (per Month)',
    suggestPrice: 'Suggest price',
    category: 'Category',
    status: 'Status',
    private: 'Plan is private',
    visibility: 'Visibility',
    renewable: 'Renewable',
    canAddAddon: 'Can add addon',
    documentLimit: 'Document limit',
    userLimit: 'User limit',
    freeTrialDays: 'Free trial days',
    product: 'Product',
    description: 'Description',
    currentPlan: 'Current',
    showMore: 'See more',
    showLess: 'Show less',
    modules: 'Modules',
    delete: 'Delete'
  },

  table: {
    header: {
      row: 'Row',
      logo: 'Logo',
      code: 'Code',
      name: 'Name',
      period: 'Period',
      price: 'Monthly Price',
      category: 'Category',
      product: 'Product',
      activeApps: 'Active Apps',
      documentLimit: 'Documents Limit',
      status: 'Status',
      private: 'Private',
      visibility: 'Visibility',
      delete: 'Delete',
      restore: 'Restore'
    }
  },

  statusTypes: {
    active: 'Active',
    disable: 'Disable'
  },

  periodTypes: {
    M: 'month',
    Y: 'year'
  },

  wizard: {
    checkout: {
      label: 'Review'
    }
  },

  notifications: {
    wrongInputValue: 'Input value is wrong',
    activeAppExist: 'Because active app exist, plan cant be delete',
    subscriptionsExists: 'Because subscription exist, plan cant be delete',

    insert: {
      success: 'Plan successfully created',
      error: 'Create plan has error'
    },
    edit: {
      success: 'Plan successfully updated',
      error: 'Update plan has error'
    },
    delete: {
      success: 'Plan successfully removed',
      error: 'Delete plan has error'
    },
    restore: {
      success: 'Plan successfully restored',
      error: 'Restore plan has error'
    },
    editLimits: {
      success: 'Plan limits successfully updated',
      error: 'Update plan limits has error'
    },
    parseError: {
      name: 'Name is not valid',
      code: 'Code is not valid or is used to another plan'
    }
  },

  validators: {
    permissions: 'No permission set for this plan'
  },

  confirmations: {
    delete: {
      title: 'Delete plan confirmation',
      body: 'Are you sure about delete this plan?'
    },

    routeBack: {
      title: 'Cancel create plan',
      body: 'If you leave this page, all the entered information will be lost. Are you sure you want to cancel creating plan?'
    }
  },

  list: {
    title: 'Plans'
  },

  trash: {
    title: 'Removed plans'
  },

  insert: {
    title: 'Create Plan'
  },

  edit: {
    title: 'Edit plan',
    dynamicTitle: 'Edit {name} plan'
  },

  profile: {
    title: 'Plan profile',
    dynamicTitle: '{name} plan profile',

    importantData: {
      code: 'Code',
      price: 'Price',
      status: 'Status'
    },

    actions: {
      apps: 'Apps',
      modules: 'Modules',
      addons: 'Addons',
      logs: 'Activity logs'
    }
  },

  apps: {
    title: 'Plan apps list'
  },

  modules: {
    title: 'Plan modules',

    labels: {
      inMenu: 'Menu'
    },

    edit: {
      title: 'Edit plan modules',
      dynamicTitle: 'Edit {name} plan modules'
    },
  },

  addons: {
    title: 'Plan addons',

    labels: {
      inMenu: 'Menu'
    },

    edit: {
      title: 'Edit plan addons',
      dynamicTitle: 'Edit {name} plan addons'
    },
  },

  categories: {
    menu: 'Categories',
    title: 'Categories',

    general: {
      labels: {
        none: 'None',
        name: 'Title',
        slug: 'Slug',
        product: 'Product',
        description: 'Description',
        withoutCategory: 'Without category',
        productCount: '{count} products'
      },

      notifications: {
        parseError: {
          name: 'Title is not valid or exist',
          slug: 'Slug is not valid or exist'
        },

        insert: {
          success: 'Category created successfully',
          error: 'Adding category was associated with an error'
        },
        edit: {
          success: 'Category edited successfully',
          error: 'Editing category failed'
        },
        delete: {
          success: 'Category deleted successfully',
          error: 'Delete category associated failed',
          isUsed: 'This category is used and cant delete'
        }
      },

      validators: {
        attributeExist: 'Attribute { name } is in this category',
        noChange: 'No changes have been made'
      },

      confirmations: {
        delete: {
          title: 'Delete Category',
          body: 'Are you sure you want to delete {name}? '
        }
      }
    },

    list: {
      title: 'Categories'
    },

    insert: {
      title: 'Create category'
    },

    edit: {
      title: 'Edit Category'
    }
  },

  logs: {
    title: 'Plan Logs'
  }
}
